import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["newFilename"]

  prefillWithUploadedFilenames(event) {
    event.preventDefault()
    this.newFilenameTargets.forEach(filename => {
      filename.value = filename.dataset.uploadedFilename.replace(/\s/g, "").replace(/lot/gi, "")
    })
  }
}
